<template>
<div class="search-box">
  <j-modal
    title="搜索"
    :width="530"
    :visible="visible"
    :closable="false"
    @cancel="handleCancel"
    :mask="false"
    class="j-super-query-modal"
    style="top:5%;max-height: 95%;"
  >
    <template slot="footer">
      <div>
        <a-button :loading="loading" style="width: 100%"  @click="handleReset">重置</a-button>
      </div>
      <div>
        <a-button :loading="loading" style="width: 100%;margin-top: 12px" type="primary" @click="handleOk">搜索</a-button>
      </div>
    </template>
    <div class="super-top">
      <div style="color: #0A1629;font-size:22px;color: rgba(10, 22, 41, 1)">搜索<span style="color: rgba(125, 133, 146, 1);font-size: 14px;margin-left: 24px">可选一项或多项同时搜索</span></div>
      <div style="color: #7D8592;cursor: pointer" class="delete-order"  @click="handleCancel">
          <img class="icon" src="@/assets/driver/delete.png"/>
      </div>
    </div>
    <div class="search-content">
      <a-row>
        <a-col v-for="query in queryList" style="margin-bottom: 24px">
          <div class="search-title">{{query.name}}</div>
          <j-input :placeholder="query.name" style="width: 100%" v-model="query.value" v-if="query.type==1"></j-input>
          <j-dict-select-tag  v-else-if="query.type==2" :placeholder="query.name" v-model="query.value" :dictCode="query.dictCode" style="width: 100%"/>
          <j-search-select-tag
            v-else-if="query.type==3"
            :placeholder="query.name"
            v-model="query.value"
            :dictOptions="query.dictOptions" style="width: 100%">
          </j-search-select-tag>
        </a-col>
      </a-row>

    </div>
  </j-modal>
  <a-input placeholder="搜索" @click="show" @focus="show"   style="width: 320px;cursor: pointer"></a-input>
</div>

</template>

<script>


  import ARow from "ant-design-vue/es/grid/Row";
  import ACol from "ant-design-vue/es/grid/Col";
  export default {
    name: 'TopTab',
    components: {ACol, ARow},
    props: {
      queryList: {
        type: Array,
        default: []
      }
    },data(){
      return {
        visible:false,
        loading:false
      }
    },methods:{
      handleCancel(){
        this.visible = false
      },show(){
        this.visible = true;
      },handleOk(){

        this.visible = false;
        this.searchQuery();
      },searchQuery(){
        this.$emit("search",this.queryList);
      },handleReset(){
        for(let a in this.queryList){
          this.queryList[a].value=null;
        }
        this.searchQuery();
      }
    }
  }
</script>
<style lang="less" scoped>

  .super-top{
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba(230, 237, 245, 1);
    padding: 24px;
    font-size: 16px
  }

  .j-super-query-modal{
    font-family: 'Syht';
    /deep/ .ant-tree-node-content-wrapper {
      width: 100%;
    }
    /deep/ .ant-radio-inner{
      width: 21px !important;
      height: 21px !important;
    }
    /deep/ .ant-radio-inner{
      border:2px solid  #0A1629 !important;
    }
    /deep/ .ant-radio-checked .ant-radio-inner{
      border:2px solid  #0A1629 !important;
    }
    /deep/ .ant-radio-inner::after{
      width:10px !important;
      height: 10px !important;
      top:3px !important;
      left: 3.5px !important;
    }

    /deep/ .ant-modal-content{
      border-radius: 12px !important;
    }
    /deep/ .ant-modal-header{
      border-radius:12px 12px 0 0;
      display: none !important;
    }
    /deep/ .ant-modal-body{
      padding: inherit;
    }

    /deep/ .ant-select-arrow{
      color: #1890ff !important;
    }


    .delete-order{
      padding: 0 10px;
      text-align: center;
      border-radius: 12px;
      cursor: pointer;
      background: rgba(244, 249, 253, 1);
      width: 44px;
      height: 44px;
      line-height: 44px;
    }
    .delete-order img{
      width: 24px;
      height: 24px;
    }
    .delete-order:hover{
      opacity: .8;
    }

    /deep/ .ant-modal-footer{
      border-top: none !important;
    }
    .search-content{
      padding: 24px;
      .search-title{
        font-size: 16px;
        color: rgba(10, 22, 41, 1);
        margin-left: 6px;
        margin-bottom: 12px;
      }
      /deep/ .ant-select{
        width: 100%;
      }
    }
  }

</style>